import React from 'react';
import { isColorBright } from '../../lib/ep';

const GalleryCoverEmbed = (props) => {
	const type = (props.type != undefined) ? props.type : 'big';
	const main_color = (props.main_color != undefined) ? props.main_color : ((props.color != undefined) ? props.color : '#2951CC');
	const text_color = (isColorBright(main_color)) ? 'black' : 'white';

	const title = (props.title != undefined) ? props.title : false;
	let description = ((type != 'thumb') && props.description != undefined) ? props.description : false;
	if(type == 'gallery' && description && description.trim().length > 100) description = description.substr(0, 100).trim() + "...";

	if(!title && !description) return null;

	const author = props?.author ?? false;
	const date = props?.date ?? false;

	return (
		<div class={`gallery_description is_${type}`} style={{background:main_color}}>
			<div class={'cover_info' + ((author) ? ' with_autor' : '')}>
				{(title) && (
					<h4 class="is_title original_color_item mod_align_center" style={{color:text_color}} dangerouslySetInnerHTML={{ __html:title.replace(/\n/g, '<br />') }} />
				)}

				{(description) && (
					<p class="is_description original_color_item mod_align_center" style={{color:text_color}} dangerouslySetInnerHTML={{ __html:description.replace(/\n/g, '<br />') }} />
				)}
			</div>

			{(author) && (
				<div class="author_in_cover">
					<h5 class="is_author original_color_item" style={{color:text_color}}>{author}</h5>
					{(date) && (
						<p class="is_date original_color_item" style={{color:text_color}}>{EPDateFormat(date, 'LL')}</p>
					)}
				</div>
			)}
		</div>
	)
};

export default GalleryCoverEmbed;